import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import NoDataFound from "../../../components/NoDataFound";

import "../../../styles/app.scss";
import ImageLoading from "../../../components/ImageLoading";
function NotDisbursedTable({
  setInvokeCount,
  invocationState,
  setTotalPages,
  setTotalRows,
  pageNo,
  rowsPerPage,
  searchValue,
  setEndIndex,
  setSelectArray,
  reRender,
  setReRender,
}) {
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [list, setList] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);

  const handleSelectAll = () => {
    setSelectAll((prevSelectAll) => {
      const newValue = !prevSelectAll;
      if (newValue) {
        setSelectedItems(
          list
            .filter((item) => item.type !== "OD")
            .map((_, index) => _.order_uuid)
        );
      } else {
        setSelectedItems([]);
      }
      return newValue;
    });
  };
  const fetchDpd = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/revoke/loan_not_disbursed?page=${pageNo}&per_page=${rowsPerPage}&filter_name=${searchValue}`,
        options
      );
      setTotalPages(res.data.total_page_count);
      setTotalRows(res.data.total_records);
      setList(res.data.invoke_data);
      setImageLoading(false);

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fetchDpdInitiated = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/revoke/loan_not_disbursed?page=${pageNo}&per_page=${rowsPerPage}&filter_name=${searchValue}&initiate_revoked=true`,
        options
      );
      setTotalPages(res.data.total_page_count);
      setTotalRows(res.data.total_records);
      setList(res.data.invoke_data);
      setImageLoading(false);

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  function replaceUnderscore(str) {
    return str.replace(/_/g, " ");
  }

  const handleSelectItem = (index) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedItems = [...prevSelectedItems];
      const itemIndex = updatedItems.indexOf(index);
      if (itemIndex !== -1) {
        updatedItems.splice(itemIndex, 1);
      } else {
        updatedItems.push(index);
      }
      setSelectAll(
        updatedItems.length === list.filter((item) => item.type !== "OD").length
      );
      return updatedItems;
    });
  };

  function formatToIndianRupees(num) {
    // Convert the number to a string
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }
  const formatInvokeDate = (date) => {
    return ` ${5 - date} days ago`;
  };
  function truncateText(text, maxLength) {
    if (text === null) return "---";
    if (text.length > maxLength) {
      return text.slice(0, maxLength - 3) + "...";
    }
    return text;
  }

  useEffect(() => {
    setSelectArray(selectedItems);
    setInvokeCount(selectedItems.length);
  }, [selectedItems]);
  useEffect(() => {
    const controller = new AbortController();
    setSelectedItems([]);
    setSelectAll(false);
    if (invocationState === "initiatedInvocation") {
      fetchDpdInitiated(controller);
    } else {
      fetchDpd(controller);
    }
    return () => {
      controller.abort();
    };
  }, [pageNo, rowsPerPage, searchValue, invocationState, reRender]);
  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);

  const getStatusColor = (status, type) => {
    const colorMap = [
      {
        keywords: ["Bank Details", "Initiated", "Pending"],
        bg: "#cce2fb",
        text: "#1963ba",
      },
    ];
    for (const { keywords, bg, text } of colorMap) {
      if (keywords.some((keyword) => status.includes(keyword))) {
        return type === "bg" ? bg : text;
      }
    }
    return type === "bg" ? "#DBE8DB" : "#0BA300";
  };

  return (
    <div className=" pt-3  w-full bg-white">
      {imageLoading && (
        <div className="w-full h-[calc(100vh-248px)] flex items-center justify-center">
          <ImageLoading />
        </div>
      )}
      {list.length < 1 && !imageLoading ? (
        <div className="w-full h-[calc(100vh-248px)] flex items-center justify-center">
          <NoDataFound />
        </div>
      ) : (
        <>
          {" "}
          {!imageLoading && (
            <table className="w-full box-border h-full flex flex-col">
              <thead className="text-sm font-semibold h-full">
                <tr className="w-full flex items-center">
                  <th className="text-center pl-6 pr-4 pt-3 pb-2 w-[5%]">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={(e) => handleSelectAll(e)}
                      className="border-2 border-[#00394d] focus:border-[#00394d]"
                    />
                  </th>
                  <th
                    className={`text-left ${
                      invocationState === "initiatedInvocation"
                        ? "w-[16%]"
                        : "w-[16%]"
                    }`}
                  >
                    Name
                  </th>
                  <th
                    className={`text-left pl-4 ${
                      invocationState === "initiatedInvocation"
                        ? "w-[18%]"
                        : "w-[18%]"
                    }`}
                  >
                    Reference No.
                  </th>
                  <th className="text-left  w-[8%]">Distributor</th>
                  {/* <th
                   className={`text-right ${
                     invocationState === "initiatedInvocation"
                       ? "w-[15%]"
                       : "w-[15%]"
                   }`}
                 >
                   Total Assets Value
                 </th> */}
                  <th
                    className={`text-right ${
                      invocationState === "initiatedInvocation"
                        ? "w-[18%]"
                        : "w-[18%]"
                    }`}
                  >
                    Pledged assets value
                  </th>
                  <th
                    className={`text-right ${
                      invocationState === "initiatedInvocation"
                        ? "w-[18%]"
                        : "w-[18%]"
                    }`}
                  >
                    Pledge Date
                  </th>
                  {/* {<th className=" text-right w-[14%]"> EMI amount/month</th>} */}
                  <th
                    className={`text-center pl-4 ${
                      invocationState === "initiatedInvocation"
                        ? "w-[20%]"
                        : "w-[20%]"
                    }`}
                  >
                    Status
                  </th>
                </tr>
              </thead>

              <tbody className="  overflow-auto  max-h-[calc(100vh-285px)]">
                {list.map((data, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                    } text-xs font-medium w-full flex items-center ${
                      selectedItems.includes(data.order_uuid) && "!bg-[#b0c2c8]"
                    }`}
                  >
                    <td className="text-center pl-6 pr-4 pt-3 pb-2 w-[5%]">
                      <input
                        title={
                          data.type === "OD" &&
                          "Overdraft orders cannot be revoked"
                        }
                        disabled={data.type === "OD"}
                        type="checkbox"
                        checked={selectedItems.includes(data.order_uuid)}
                        onChange={() => handleSelectItem(data.order_uuid)}
                      />
                    </td>
                    <td
                      title={data.name?.length > 25 ? data.name : ""}
                      className={`text-left ${
                        invocationState === "initiatedInvocation"
                          ? "w-[16%]"
                          : "w-[16%]"
                      }`}
                    >
                      {truncateText(data.name, 25) || "---"}
                    </td>
                    <td
                      className={`text-left pl-4 text-[#004682] ${
                        invocationState === "initiatedInvocation"
                          ? "w-[18%]"
                          : "w-[18%]"
                      }`}
                    >
                      <Link
                        to={`../individuals/${data.user_uuid}?name=${
                          data.name
                        }&od=${data.type === "OD" ? "true" : "false"}`}
                      >
                        {data.reference_no}{" "}
                      </Link>
                    </td>
                    <td className="text-left  w-[8%]">
                      {truncateText(data.distributor_name, 15)}
                    </td>
                    {/* <td
                     className={`text-right ${
                       invocationState === "initiatedInvocation"
                         ? "w-[15%]"
                         : "w-[15%]"
                     }`}
                   >
                     {data.pledged_asset_value}
                   </td> */}
                    <td
                      className={`text-right ${
                        invocationState === "initiatedInvocation"
                          ? "w-[18%]"
                          : "w-[18%]"
                      }`}
                    >
                      {formatToIndianRupees(data.pledged_asset_value)}
                    </td>
                    <td
                      className={`text-right ${
                        invocationState === "initiatedInvocation"
                          ? "w-[18%]"
                          : "w-[18%]"
                      }`}
                    >
                      {data.pledged_date}
                    </td>
                    {/* {<td className="text-right w-[14%]">21-21-2002</td>} */}
                    <td className="text-center w-[20%] pl-8 text-[10px]">
                      <span
                        style={{
                          background: getStatusColor(data.status, "bg"),
                          color: getStatusColor(data.status, "text"),
                        }}
                        className=" py-1 px-2   rounded-xl  mr-2"
                      >
                        {replaceUnderscore(data.status)}{" "}
                      </span>
                      {invocationState === "initiatedInvocation" && (
                        <span className=" text-[#262626]">
                          {formatInvokeDate(data.revoke_date)}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}
    </div>
  );
}

export default NotDisbursedTable;
